import React, { useEffect } from 'react';

import DefaultLayout from '../../layout/DefaultLayout';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';

import { useCashSession } from '../../hooks/cash/useCashSession';
import { useCashReport } from '../../hooks/cash/useCashReport';

import { useCashXPdf } from '../../hooks/pdf/useCashXPdf';
import { usePrintService } from '../../hooks/printing/usePrintService';

import CashClosingXDashboard from '../../components/CashClosingX/CashClosingXDashboard';

const CashClosingXPage: React.FC = () => {
  const { activeSession } = useCashSession();

  const { report, getXReport, loading } = useCashReport();

  const { handleDownloadCashXPdf } = useCashXPdf();

  const { requestLegacyPrint, isPrinting } = usePrintService();

  useEffect(() => {
    if (!activeSession?.id) {
      return;
    }

    getXReport();
  }, [activeSession?.id]);

  const handleGenerate = () => {
    getXReport();
  };

  /**
   * 🖨️ Imprimir Ticket Corte X
   */
  const handlePrintTicket = () => {
    if (!activeSession?.id) {
      return;
    }

    void requestLegacyPrint('CASH_X', activeSession.id).catch(() => undefined);
  };

  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      <div className="space-y-6 pb-6">
        <CashClosingXDashboard
          report={report}
          loading={loading}
          printPending={isPrinting}
          onGenerate={handleGenerate}
          onPrintTicket={handlePrintTicket}
          onDownloadPdf={handleDownloadCashXPdf}
        />
      </div>
    </DefaultLayout>
  );
};

export default CashClosingXPage;
